import { useLayoutEffect, useState, type RefObject } from 'react';

/** Tracks the trigger's viewport rect so a portaled menu can anchor to it. */
export function useAnchorRect(anchorRef: RefObject<HTMLElement | null>, open: boolean) {
  const [rect, setRect] = useState<{ top: number; left: number; width: number; bottom: number } | null>(null);

  useLayoutEffect(() => {
    if (!open) {
      setRect(null);
      return;
    }

    const update = () => {
      const el = anchorRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      setRect({ top: r.top, left: r.left, width: r.width, bottom: r.bottom });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [anchorRef, open]);

  return rect;
}
